import React, {Fragment} from 'react';
import {compose} from 'redux';
import {connect} from "react-redux";
import {translate} from 'react-i18next';
import {Form, Input, InputNumber, Select, Row, Col, Checkbox} from 'antd';
import _ from "lodash";
import {changeAppConfigDataManagementForm} from "./actions";
import LanguageForm from "./LanguageForm";
import FormList from "../../../components/form-list";
import ZoomableTextArea from "../../../components/zoomable-textarea";
import { GUTTER_MD } from '../../../styles/constants';

const mapStateToProps = state => ({
  DataManagement: state.scenes.configuration.appConfig.config.DataManagement
});

const mapDispatchToProps = dispatch => ({
  onChange: fields => dispatch(changeAppConfigDataManagementForm(fields))
});

const mapPropsToFields = ({DataManagement}) => ({
  CubeCodePrefix: Form.createFormField({value: DataManagement !== null ? DataManagement.CubeCodePrefix : null}),
  DataLanguages: Form.createFormField({value: DataManagement !== null ? DataManagement.DataLanguages : null}),
  MaxDescriptionLength: Form.createFormField({value: DataManagement !== null ? DataManagement.MaxDescriptionLength : null}),
  DatasetPrefix: Form.createFormField({value: DataManagement !== null ? DataManagement.DatasetPrefix : null}),
  StruvalFormat: Form.createFormField({value: DataManagement !== null ? DataManagement.StruvalFormat : null}),
  SingleColumn: Form.createFormField({value: DataManagement !== null ? DataManagement.SingleColumn : null}),
  LimitPagingMa: Form.createFormField({value: DataManagement !== null ? DataManagement.LimitPagingMa : null}),
  MaxRowsErrorMappingValidation: Form.createFormField({value: DataManagement !== null ? DataManagement.MaxRowsErrorMappingValidation : null}),
  BlackListQueryWord: Form.createFormField({value: DataManagement !== null ? DataManagement.BlackListQueryWord : null}),
});


const onFieldsChange = (props, fields) => props.onChange(_.mapValues(fields, ({value}) => value));

const DataManagementForm = ({
                              t,
                              form,
                              DataManagement,
                              onChange
                            }) => {

  const options = [
    {
      label: "Compact Data v2.0",
      value: "compactdata"
    },
    {
      label: "CrossSectional Data v2.0",
      value: "crossdata"
    },
    {
      label: "Generic Data v2.0",
      value: "genericdata20"
    }  ,
    {
      label: "Generic Data v2.1",
      value: "genericdata"
    }  ,
    {
      label: "Structure Specific Data v2.1",
      value: "structurespecificdata"
    }
  ]

  return (
  <Fragment>
    <Form>
      <Form.Item
        label={t("data.appConfig.dataManagementForm.cubeCodePrefix.label")}
        style={{marginBottom: 0}}
      >
        {form.getFieldDecorator("CubeCodePrefix")(
          <Input
            title={form.getFieldValue("CubeCodePrefix")}
          />
        )}
      </Form.Item>
      <Form.Item
        label={t("data.appConfig.dataManagementForm.datasetPrefix.label")}
        style={{marginBottom: 0}}
        className="form-item-required"
      >
        {form.getFieldDecorator("DatasetPrefix")(
          <Input
            title={form.getFieldValue("DatasetPrefix")}
            type='text'
          />
        )}
      </Form.Item>
      <Form.Item
        label={t("data.appConfig.dataManagementForm.struvalFormat.label")}
        style={{marginBottom: 0}}
      >
        {form.getFieldDecorator("StruvalFormat")(
          <Select
              style={{ width: '100%' }}
              title={form.getFieldValue("StruvalFormat")}
          >
            {options.map(option => {
              return (
                <Select.Option key={option.value} value={option.value} title={option.label}>{option.label}</Select.Option>
                )
            })}
          </Select>
        )}
      </Form.Item>
      <Form.Item
        label={t("data.appConfig.dataManagementForm.limitPagingMa.label")}
        style={{marginBottom: 0}}
        className="form-item-required"
      >
        {form.getFieldDecorator("LimitPagingMa")(
          <Input
            title={form.getFieldValue("LimitPagingMa")}
            type='number'
          />
        )}
      </Form.Item>
      <Form.Item
          label={t("data.appConfig.dataManagementForm.maxRowsErrorMappingValidation.label")}
          style={{marginBottom: 0}}
          className="form-item-required"
      >
        {form.getFieldDecorator("MaxRowsErrorMappingValidation")(
            <Input
                title={form.getFieldValue("MaxRowsErrorMappingValidation")}
                type='number'
            />
        )}
      </Form.Item>
      <Row type="flex" justify="start" align="middle" gutter={GUTTER_MD} style={{marginBottom: 0}}>
        <Col style={{color: 'rgba(0, 0, 0, 0.85)'}}>
          {t("data.appConfig.dataManagementForm.singleColumnFlag.label") + ' :'}
        </Col>
        <Col>
          <Form.Item>
            {form.getFieldDecorator("SingleColumn", {valuePropName: 'checked'})(
              <Checkbox
                title={form.getFieldValue("SingleColumn")}
              />
            )}
          </Form.Item>
        </Col>
      </Row>
      <Form.Item
          label={t("data.appConfig.dataManagementForm.blackListQueryWord.label")}
          style={{marginBottom: 0}}
          className="form-item-required"
      >
        {form.getFieldDecorator("BlackListQueryWord")(
            <ZoomableTextArea
                title={form.getFieldValue("BlackListQueryWord")}
            />
        )}
      </Form.Item>
    </Form>
    <Form.Item
      label={t("data.appConfig.dataManagementForm.dataLanguages.label")}
      className="form-item-required"
      style={{marginBottom: 0}}
    >
      <FormList
        compact
        values={DataManagement ? DataManagement.DataLanguages : null}
        Component={LanguageForm}
        newItem={{
          code: null,
          flag: null
        }}
        minItems={1}
        addItemLabel={t("data.appConfig.dataManagementForm.dataLanguages.buttons.add.label")}
        removeItemLabel={t("data.appConfig.dataManagementForm.dataLanguages.buttons.remove.label")}
        onChange={langs => onChange({DataLanguages: langs})}
      />
    </Form.Item>
    <Form.Item
      label={t("data.appConfig.dataManagementForm.maxDescriptionLength.label")}
      className="form-item-required"
      style={{marginBottom: 0}}
    >
      {form.getFieldDecorator("MaxDescriptionLength")(
        <InputNumber
          title={form.getFieldValue("MaxDescriptionLength")}
          min={0}
          style={{width: "100%"}}
        />
      )}
    </Form.Item>
  </Fragment>
)}

export default compose(
  translate(),
  connect(mapStateToProps, mapDispatchToProps),
  Form.create({mapPropsToFields, onFieldsChange})
)(DataManagementForm);
